import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ClearedRec16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_307)'>
      <path
        d='M7.00012 10.0605L12.0608 5.00001L11.0001 3.93934L7.00011 7.93925L5.00009 5.93934L3.93946 7.00003L7.00012 10.0605Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.5 0.749939C0.809643 0.749939 0.25 1.30958 0.25 1.99994V11.4999C0.25 12.1903 0.809634 12.7499 1.49998 12.7499L3.25003 12.75V14.2928C3.25003 15.4065 4.59646 15.9642 5.38391 15.1767L7.81066 12.7499H14.5C15.1904 12.7499 15.75 12.1903 15.75 11.4999V1.99994C15.75 1.30958 15.1904 0.749939 14.5 0.749939H1.5ZM1.75 11.2499V2.24994H14.25V11.2499H7.18934L4.75003 13.6893V11.25L1.75 11.2499Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_307'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ClearedRec16.displayName = 'ClearedRec16';
export default ClearedRec16;
